import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
     onUpdateColumn,
     setOrder,
     setSelectedRow
} from '../../../store/fuerzaventas/preciostock/actions';
import { sort_by} from '../../../helpers/commons'

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const PrecioStockList = () => {
    const classes = useStyles();
    const columns = useSelector(state => state.preciostock.table.columns);
    const loadingStore = useSelector(state => state.preciostock.store.loading);
    const order = useSelector(state => state.preciostock.table.order);
    const orderBy = useSelector(state => state.preciostock.table.orderBy);
    const store = useSelector(state => state.preciostock.store);
    const dispatch = useDispatch();

    const handleDoubleClick = (id) => {
        /*
        history.push({
            hash: location.hash,
            pathname: `/fuerzaventas/vendedor/${id}`,
            search: location.search
        });
        */
    }   
    
//     function handleChangePage(newPage) {
//         dispatch(setPage(newPage));
//         dispatch(btnSearch());
//  }
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
    };
    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    };

    // function handleChangeRowsPerPage(event) {
    //     dispatch(setPageSize(event.target.value));
    //     dispatch(setPage(0));
    // }

     return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loadingStore}
                    //onChangePage={handleChangePage}
                    //onChangeRowsPerPage={handleChangeRowsPerPage}
                    onRowClick={items => dispatch(setSelectedRow(items))}
                    onRowDoubleClick={item => handleDoubleClick(item.usuarioId)}
                    onSort={datakey => handleRequestSort(datakey)}
                    onUpdateColumn={handleResizeColumn}
                    // page={store.start/store.pageSize}
                    // paginate
                    rowCount={store.data.length}
                    rowGetter={index =>  store.data[index] }
                    rowsPerPage={store.pageSize}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                />
            </div>
        </FieldSet>
    )
};

export default PrecioStockList;